import ChipColors from './ChipColors';

export default [
  {
    text: 'Bloqueado',
    value: true,
    ...ChipColors.danger,
  },
  {
    text: 'Desbloqueado',
    value: false,
    ...ChipColors.success,
  },
];
